export default __webpack_public_path__ + "static/media/C_ic.f3fb7416.svg";